import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import defaultPreview from "../../assets/images/default.jpg";
import { getFullImageUrl } from "./ImageSet";

const ImageSliderModal = ({
  isOpen,
  onClose,
  images = [],
  initialSlide = 0,
  defaultImage = defaultPreview,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.95)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
    >
      {/* Close Button */}
      <div
        style={{
          position: "absolute",
          top: "20px",
          right: "30px",
          fontSize: "40px",
          color: "#fff",
          cursor: "pointer",
          zIndex: 10001,
          transition: "transform 0.2s",
        }}
        onClick={onClose}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "rotate(90deg)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "rotate(0deg)";
        }}
      >
        <i className="fa-solid fa-xmark"></i>
      </div>

      {/* Swiper Slider */}
      <div
        style={{ width: "100%", maxWidth: "1000px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{
            clickable: true,
            type: "fraction",
          }}
          initialSlide={initialSlide}
          loop={images.length > 1}
          style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
            "--swiper-navigation-size": "30px",
          }}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "20px 0",
                }}
              >
                <img
                  src={getFullImageUrl(image) || defaultImage}
                  alt={`Slide ${index + 1}`}
                  style={{
                    width: "60vh",
                    height: "90vh",
                    objectFit: "cover",
                    borderRadius: "12px",
                    boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
                  }}
                  crossOrigin="anonymous"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultImage;
                  }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ImageSliderModal;
